import React, { useRef, useEffect } from 'react'
import styles from './Flow.module.scss'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

type Props = {
  contents: {
    items: {
      num: string
      title: string
      description: React.ReactNode
      planItems: string[]
    }[]
  }
}

const Flow: React.FC<Props> = ({ contents }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)
  const descriptionRefs = useRef<(HTMLParagraphElement | null)[]>([])

  useEffect(() => {
    const adjustHeights = () => {
      const descriptions = descriptionRefs.current
      if (!descriptions.length) return

      descriptions.forEach((el) => {
        if (el) el.style.height = 'auto'
      })

      if (window.innerWidth >= 720) {
        for (let i = 0; i < descriptions.length; i += 2) {
          const left = descriptions[i]
          const right = descriptions[i + 1]

          if (left && right) {
            const maxHeight = Math.max(left.scrollHeight, right.scrollHeight)
            left.style.height = `${maxHeight}px`
            right.style.height = `${maxHeight}px`
          }
        }
      }
    }

    adjustHeights()
    window.addEventListener('resize', adjustHeights)

    return () => window.removeEventListener('resize', adjustHeights)
  }, [contents])

  return (
    <section
      className={`${styles.flow} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.inner}>
        <div className={styles.leftArea}>
          <h2 className={styles.flowTitle}>サービスの流れ</h2>
          <p className={styles.flowDescription}>
            戦略・UX・テクノロジー・運用改善のすべてを一つのチームで完結させる。
            <br />
            これが、Aitriaが提供する"成果の出るアプリ開発"のかたちです。
          </p>
        </div>
        <div className={styles.rightArea}>
          {contents.items.map((item, index) => (
            <article key={index} className={styles.flowList}>
              <p className={styles.flowList__num}>
                <span>STEP</span>
                {item.num}
              </p>
              <h3 className={styles.flowList__title}>{item.title}</h3>
              <p className={styles.flowList__description} ref={(el) => (descriptionRefs.current[index] = el)}>
                {item.description}
              </p>
              <ul className={styles.flowList__plan}>
                {item.planItems.map((planItem, planIndex) => (
                  <li key={planIndex} className={styles.flowList__plan__item}>
                    {planItem}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
export default Flow
